import styled from "styled-components";

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HelperTextStyle: React.CSSProperties = {
	color: "#6b7280",
	fontSize: "12px",
	marginLeft: "10px"
};
 